import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../accordian';
import { signUpFlow } from '../hook';
import Modal from '../../Modal';
import styles from './Lite_InjectScriptForm.module.css';
import Input, { TextArea } from '../../input/input';

const inputGroupStyle = { marginTop: '-8px' };

const Lite_InjectScriptForm = () => {
  const [data, setData] = useState({
    accessKey: '',
    contentSelector: '',
    primaryColor: '',
    logoUrl: '',
    paywallSourceUrl: '',
    monetizeType: 'tipjar',
    contentPreviewHeight: '200',
    bubblePosition: 'right',
    mobileOffsetVertical: '20%',
    mobileOffsetHorizontal: '1%',
    desktopOffsetVertical: '20%',
    desktopOffsetHorizontal: '2%',
    borderless: false,
    infiniteScroll: false,
    functionSelector: '',
    eventHandlers: '',
    shouldInjectPaywall: ''
  });

  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [responseMessage, setResponseMessage] = useState('');

  const createAdmin = signUpFlow();

  const handleModalText = (text) => {
    setModalText(text);
  };

  const handleResponseMessage = (text) => {
    setResponseMessage(text);
  };

  const handleTipjarChange = () => {
    setData({ ...data, monetizeType: 'tipjar' });
  };

  const handlePaywallChange = () => {
    setData({ ...data, monetizeType: 'paywall' });
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    console.log('data get', JSON.stringify(data));
    setShowModal(true);
    createAdmin(data, handleModalText, setShowModal, handleResponseMessage);
  };

  const renderButton = () => {
    return (
      <>
        <input
          disabled={
            data.accessKey === '' ||
            data.contentSelector === '' ||
            data.primaryColor === '' ||
            data.logoUrl === '' ||
            data.paywallSourceUrl === ''
          }
          type="button"
          onClick={handleSubmit}
          value="Inject"
          id={styles['signup-form__submit']}
        />
      </>
    );
  };

  return (
    <form id={styles['signup-form']}>
      <Input
        required
        type="text"
        name="accessKey"
        onChange={handleChange}
        value={data.accessKey}
        placeholder="Access Key"
        className={styles['signup-form__input']}
      />
      <Input
        required
        type="text"
        name="contentSelector"
        onChange={handleChange}
        value={data.contentSelector}
        placeholder="Content Selector"
        className={styles['signup-form__input']}
      />
      <Input
        required
        type="text"
        name="primaryColor"
        onChange={handleChange}
        value={data.primaryColor}
        placeholder="Primary Color"
        className={styles['signup-form__input']}
      />
      <Input
        required
        type="url"
        name="logoUrl"
        onChange={handleChange}
        value={data.logoUrl}
        placeholder="Logo URL"
        className={styles['signup-form__input']}
      />
      <Input
        required
        type="url"
        name="paywallSourceUrl"
        onChange={handleChange}
        value={data.paywallSourceUrl}
        placeholder="Paywall Source Url"
        className={styles['signup-form__input']}
      />
      <Accordion title="More Fields (Optional)">
        <div className={styles['fc-input-group']} style={inputGroupStyle}>
          <Input
            required
            type="number"
            name="contentPreviewHeight"
            onChange={handleChange}
            value={data.contentPreviewHeight}
            placeholder="Preview Height"
            className={styles['signup-form__input']}
          />
          <Input
            required
            type="text"
            name="bubblePosition"
            onChange={handleChange}
            value={data.bubblePosition}
            placeholder="Bubble Position"
            className={styles['signup-form__input']}
          />
        </div>
        <div className={styles['fc-control-group']}>
          <label>Mobile Bubble Offset</label>
          <div className={styles['fc-input-group']}>
            <Input
              required
              type="text"
              name="mobileOffsetHorizontal"
              onChange={handleChange}
              value={data.mobileOffsetHorizontal}
              placeholder="Horizontal"
              className={styles['signup-form__input']}
            />
            <Input
              required
              type="text"
              name="mobileOffsetVertical"
              onChange={handleChange}
              value={data.mobileOffsetVertical}
              placeholder="Vertical"
              className={styles['signup-form__input']}
            />
          </div>
        </div>

        <div className={styles['fc-control-group']}>
          <label>Desktop Bubble Offset</label>
          <div className={styles['fc-input-group']}>
            <Input
              required
              type="text"
              name="desktopOffsetHorizontal"
              onChange={handleChange}
              value={data.desktopOffsetHorizontal}
              placeholder="Horizontal"
              className={styles['signup-form__input']}
            />
            <Input
              required
              type="text"
              name="desktopOffsetVertical"
              onChange={handleChange}
              value={data.desktopOffsetVertical}
              placeholder="Vertical"
              className={styles['signup-form__input']}
            />
          </div>
          <div className={styles['fc-input-group']}>
            <TextArea
              name="eventHandlers"
              placeholder="Plugin Event Handlers"
              rows="4"
              value={data.eventHandlers}
              className={styles['signup-form__input']}
              onChange={handleChange}
            ></TextArea>
          </div>
          <div className={styles['fc-input-group']}>
            <TextArea
              name="shouldInjectPaywall"
              placeholder="Callback to conditionally inject paywall"
              rows="4"
              value={data.shouldInjectPaywall}
              className={styles['signup-form__input']}
              onChange={handleChange}
            ></TextArea>
          </div>
          <div className={styles['fc-input-group']}>
            <TextArea
              name="functionSelector"
              placeholder="A js function to dynamically find the content selector"
              rows="4"
              value={data.functionSelector}
              className={styles['signup-form__input']}
              onChange={handleChange}
            ></TextArea>
          </div>
          <div className={styles['fc-input-group']}>
            <span>
              <input
                type="checkbox"
                value={data.infiniteScroll}
                onChange={() => {
                  const nextData = { infiniteScroll: !data.infiniteScroll };
                  if (!nextData.infiniteScroll) {
                    nextData.functionSelector = '';
                  }
                  setData({ ...data, ...nextData });
                }}
              ></input>
              Infinite Scroll
            </span>

            <span>
              <input
                type="checkbox"
                value={data.borderless}
                onChange={() => {
                  setData({ ...data, borderless: !data.borderless });
                }}
              ></input>
              Borderless
            </span>
          </div>
        </div>
      </Accordion>

      <p className={styles['signup-form__input']}>
        <RadioButton label="Paywall " value={data.monetizeType === 'paywall'} onChange={handlePaywallChange} />
        <RadioButton label="Tipjar " value={data.monetizeType === 'tipjar'} onChange={handleTipjarChange} />
      </p>

      {renderButton()}

      <ValidationResult message={responseMessage} />

      {showModal && <Lite_InjectScriptModal setShowModal={setShowModal} text={modalText} />}
    </form>
  );
};

const radioStyle = { marginRight: '12px' };
const RadioButton = ({ label, value, onChange }) => {
  return (
    <label style={radioStyle}>
      <input type="radio" checked={value} onChange={onChange} />
      {label}
    </label>
  );
};

const ValidationResult = ({ message }) => <label id={styles['err-message']}>{message}</label>;

ValidationResult.propTypes = {
  message: PropTypes.node.isRequired
};

const Lite_InjectScriptModal = ({ setShowModal, text }) => (
  <Modal setShowModal={setShowModal} isLogin>
    <p>{text}</p>
  </Modal>
);

Lite_InjectScriptModal.propTypes = {
  setShowModal: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired
};

export default Lite_InjectScriptForm;
